import RadioGroup from "@p-ban/common/src/components/form/radio/RadioGroup"

import ESTIMATE_CONSTANT from "../../../../../constant/estimateConstant"
import FIELD_NAMES from "../../../../../constant/fieldNames"
import getDisplayCondition from "../../../../../service/getDisplayCondition"
import type { OneClickFieldProps } from "../../../../../types"
import OneClickField from "../../../../components/1Click/form/OneClickField"
import OneClickFieldMessages from "../../../../components/1Click/form/OneClickFieldMessages"
import OneClickFieldStack from "../../../../components/1Click/form/OneClickFieldStack"
import Radio from "../../../../components/1Click/form/Radio/Radio"
import HELP_LINKS from "../../../../constant/helpLinks"

import img from "./semiTh.png"

const 端面スルーホール = ({ values, handlers, errors }: OneClickFieldProps) => {
  const { semiTh: shouldShow } = getDisplayCondition(values)

  return (
    <OneClickField isShow={shouldShow} legend="端面スルーホール" helpURL={HELP_LINKS.端面スルーホール} src={img}>
      <RadioGroup name={FIELD_NAMES.端面スルーホール} selectedValue={values.semiTh} onChange={handlers.radio}>
        <OneClickFieldStack>
          <Radio value={ESTIMATE_CONSTANT.端面スルーホール.あり.value}>あり</Radio>
          <Radio value={ESTIMATE_CONSTANT.端面スルーホール.なし.value}>なし</Radio>
        </OneClickFieldStack>
      </RadioGroup>
      <OneClickFieldMessages error={errors?.semiTh} />
    </OneClickField>
  )
}

export default 端面スルーホール
